function checkResolution(query) {
    let active = false;

    if (!query) {
        return true;
    }

    for (let value of query.split(';')) {
        if ($('.c-var .' + value + '-is-visible').is(':visible')) {
            active = true;
        }
    }

    return active;
}

function divideSlides(slider) {
    const divide = slider.divide,
        slides = slider.elem.children();

    for (let i = 0; i < slides.length; i += divide) {
        slides.slice(i, i + divide).wrapAll('<div class="owl__tmp"></div>');
    }
}

function unDivideSlides(slider) {
    const tmpSlides = slider.dividetmpSlides = $('.owl__tmp');

    let tmpContent = '';

    for (const tmpSlide of Array.from(tmpSlides)) {
        tmpContent += $(tmpSlide).html();
    }

    slider.elem.html(tmpContent);
}

function createOwl(slider, options = {}) {
    const defaults = {
        onInitialize: function () {
            slider.active = true;
        },
        onChanged: function() {
            bLazy.revalidate();
        },
        navText: ['<i class="ico ico-arrow-left"></i>', '<i class="ico ico-arrow-right"></i>'],
        loop: true,
        nav: true,
        dots: false
    };

    slider.elem.addClass('owl-carousel owl-theme');

    if (slider.divide) {
        divideSlides(slider);
    }

    return slider.elem.owlCarousel(Object.assign(defaults, options));
}

function destroyOwl(slider) {
    slider.elem
        .removeClass('owl-carousel owl-theme')
        .trigger('destroy.owl.carousel');

    if (slider.divide) {
        unDivideSlides(slider);
    }

    slider.active = false;
}

function checkSliders(slidersGroup) {
    for (const sliderName in slidersGroup) {
        checkOwl(slidersGroup[sliderName]);
    }
}

function checkOwl(slider) {
    if (checkResolution(slider.query)) {
        if (!slider.active) {
            createOwl(slider, slider.options);
        }
    } else {
        if (slider.active) {
            destroyOwl(slider);
        }
    }
}

function createSwiper(slider, options = {}) {
    const defaults = {
        loop: true,
        on: {
            init: function () {
                slider.active = true;
            }
        }
    };

    slider.slider = new Swiper(slider.elem, Object.assign(defaults, options));
}

function destroySwiper(slider) {
    slider.slider.destroy();

    slider.active = false;
}

function checkSwipers(slidersGroup) {
    for (const sliderName in slidersGroup) {
        checkSwiper(slidersGroup[sliderName]);
    }
}

function checkSwiper(slider) {
    if (checkResolution(slider.query)) {
        if (!slider.active) {
            createSwiper(slider, slider.options);
            slider.elem.addClass('is-active');
        }
    } else {
        if (slider.active) {
            destroySwiper(slider);
            slider.elem.removeClass('is-active');
        }
    }
}